import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useBlogPost = (slug) => {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ slug: null, loading: true, post: null, error: null });
  useEffect(() => {
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug || "")) {
      setState({ slug, loading: false, post: null, error: 404 });
      return;
    }
    const controller = new AbortController();
    setState({ slug, loading: true, post: null, error: null });
    axios.get(`${API}/blog/${encodeURIComponent(slug)}`, { signal: controller.signal, timeout: 30000 })
      .then(({ data }) => setState({ slug, loading: false, post: data, error: null }))
      .catch((error) => {
        if (!axios.isCancel(error)) {
          setState({ slug, loading: false, post: null, error: error.response?.status || 503 });
        }
      });
    return () => controller.abort();
  }, [slug, attempt]);
  return {
    ...(state.slug === slug ? state : { loading: true, post: null, error: null }),
    retry: () => setAttempt((value) => value + 1),
  };
};